import HeroSection from "../components/sections/HeroSection";
import ServicePillars from "../components/sections/ServicePillars";
import AboutSnippet from "../components/sections/AboutSnippet";
import BrandsStrip from "../components/sections/BrandsStrip";
import Newsletter from "../components/sections/Newsletter";
import CtaSection from "../components/sections/CtaSection";
// import FeaturedYachts from "../components/sections/FeaturedYachts";

function HomePage() {
  return (
    <>
      <HeroSection />
      <ServicePillars />
      {/* <FeaturedYachts /> */}
      <AboutSnippet />
      <BrandsStrip />
      <Newsletter />
      <CtaSection />
    </>
  );
}

export default HomePage;
